import { Button } from '@hai/ui-react';
import { observer } from 'mobx-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StateButton } from 'src/js/component/base/state-button';

interface Props {
  onReboot?: VoidFunction;
  onStatistics?: VoidFunction;
  statisticsDisabled?: boolean;
  onSubmit?: VoidFunction;
  applyDisabled?: boolean;
  isSubmitting?: boolean;
}

export const DateTimeButtons: React.FunctionComponent<Props> = observer(
  ({ onReboot, onStatistics, statisticsDisabled, onSubmit, isSubmitting, applyDisabled = false }) => {
    const { t } = useTranslation();

    return (
      <div className="buttonRow" id="sticky-button-row">
        <div className="stickyRowOffset box">
          <div className="stickyRowPadding box">
            <Button variant="secondary" onClick={onReboot}>
              {t('general.reboot')}
            </Button>
            <Button variant="secondary" onClick={onStatistics} disabled={statisticsDisabled}>
              {t('statistics.header.statistics')}
            </Button>
            <StateButton variant="primary" isLoading={isSubmitting} onClick={onSubmit} disabled={applyDisabled}>
              {t('general.apply')}
            </StateButton>
          </div>
        </div>
      </div>
    );
  },
);
